/* sv-graphics.js, 2026-10-12: the two drawn pieces David picked from the 2026-10-11 graphics sampler, ported for the
 * live theme. Source of record: Skills/website-builder/motion/pilots/silentvalor-graphics-sampler/sampler.js
 * (ladder(), patch()); Skills/website-builder/motion/CATALOG.md names them threat-ladder and patch-stitch.
 *   threat-ladder  /pages/armor-system, How SHIELD Works. Three levels (III merged into III+, David 2026-10-12: we do
 *                  not sell a III). Point at a level, or at one of the two layer cards above, to see what it covers.
 *   patch-stitch   /pages/patches-system, Premade Designs. The patch stitches its border, draws its flag, and presses
 *                  onto the loop field; the chips pick the design and replay it. The on-bag photo, the title, the
 *                  price (resolved by the page from /products/<handle>.js) and the Add button follow the pick. Variant
 *                  ids, handles and titles live on the price spans in the markup, never here.
 * Each piece plays once when its section enters (ScrollTrigger). Reduced motion or html[data-motion="off"] shows the
 * finished state with no tween. Runs deferred; waits for GSAP, which sv-motion.js loads from cdnjs when absent. */
(function () {
  'use strict';
  var NS = 'http://www.w3.org/2000/svg', html = document.documentElement;
  function still() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches || html.getAttribute('data-motion') === 'off'; }
  function all(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, attrs, parent) { var e = document.createElementNS(NS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); if (parent) parent.appendChild(e); return e; }
  function len(p) { try { return Math.ceil(p.getTotalLength()) + 2; } catch (e) { return 1000; } }
  function prepDraw(nodes) { nodes.forEach(function (p) { var L = len(p); p.style.strokeDasharray = L + ' ' + L; p.style.strokeDashoffset = L; }); }
  function undraw(nodes) { nodes.forEach(function (p) { p.style.strokeDasharray = ''; p.style.strokeDashoffset = ''; }); }
  function drawTo(opts) { return Object.assign({ strokeDashoffset: 0, ease: 'power2.inOut' }, opts || {}); }
  function onEnter(section, fn) { ScrollTrigger.create({ trigger: section, start: 'top 72%', once: true, onEnter: fn }); }
  function whenGsap(cb) {
    var n = 0;
    (function tick() {
      if (window.gsap && window.ScrollTrigger) { gsap.registerPlugin(ScrollTrigger); return cb(true); }
      if (++n > 240) { console.warn('[sv-graphics] GSAP did not load; pieces shown finished'); return cb(false); }
      setTimeout(tick, 50);
    })();
  }

  /* ── threat-ladder (the brand's Body Armor Protection Levels chart, three levels) ─────────────── */
  function ladder(live) {
    var svg = document.getElementById('sv-tl-svg'); if (!svg || svg.childNodes.length) return;   // built once, even if the script loads twice
    var section = svg.closest('section') || svg, BASE = 570;
    var TIERS = [  // top to bottom, as the chart stacks them
      { lv: 2, name: 'LEVEL IV', kind: 'Rifle protection', prod: 'SHIELD IV plate', y: 20, w: 1000 },
      { lv: 1, name: 'LEVEL III+', kind: 'Rifle protection', prod: 'SHIELD III+ plate', y: 100, w: 860 },
      { lv: 0, name: 'LEVEL IIIA', kind: 'Handgun protection', prod: 'SHIELD IIIA panel', y: 180, w: 520 }
    ];
    var ROUNDS = [  // label, level, kind, height (the chart's own proportions), NIJ test star, tip color
      ['.40 S&W', 0, 'p', 120], ['.357 SIG', 0, 'p', 124, 1], ['9 MM', 0, 'p', 122], ['.45 ACP', 0, 'p', 132],
      ['.38 SPECIAL', 0, 'p', 157], ['.357 MAG', 0, 'p', 167], ['.44 MAG', 0, 'p', 172, 1],
      ['7.62X39MM', 1, 'r', 204], ['5.56X45MM M193', 1, 'r', 217], ['7.62X51MM M80 BALL', 1, 'r', 247, 1],
      ['5.56X45MM M855', 1, 'r', 220, 0, '#4fb6a2'], ['30-06 JSP', 1, 'r', 280],
      ['30-06 M2 AP', 2, 'r', 280, 1, '#0a0a0a']
    ];
    var XS = [52, 118, 184, 250, 318, 388, 458, 560, 616, 672, 742, 812, 930];
    var gT = el('g', {}, svg), gR = el('g', {}, svg);
    var base = el('path', { class: 'base', d: 'M0 ' + BASE + ' H1000' }, svg);
    var tiers = TIERS.map(function (t) {
      var g = el('g', { class: 'tier', 'data-lv': t.lv }, gT);
      var bar = el('rect', { class: 'bar', x: 0, y: t.y, width: t.w, height: 60, rx: 4 }, g);
      var tx = el('text', { x: t.w - 22, y: t.y + 41, 'text-anchor': 'end' }, g);
      var a = el('tspan', { class: 'lvl' }, tx); a.textContent = t.name;
      var b = el('tspan', { class: 'kind', dx: 12 }, tx); b.textContent = t.kind;
      var p = el('text', { class: 'prod', x: 20, y: t.y + 36 }, g); p.textContent = t.prod;
      return { g: g, bar: bar, t: t };
    });
    function cart(cx, h, kind) {
      var b = BASE, top = b - h, d;
      if (kind === 'p') {
        var w = 42, ch = h * .58, bw = w * .86, bh = h - ch;
        d = 'M' + (cx - w / 2) + ' ' + b + ' V' + (b - ch) + ' H' + (cx + w / 2) + ' V' + b + ' Z M' + (cx - w / 2) + ' ' + (b - 7) + ' H' + (cx + w / 2) +
            ' M' + (cx - bw / 2) + ' ' + (b - ch) + ' C' + (cx - bw / 2) + ' ' + (b - ch - bh * .75) + ' ' + (cx - bw * .14) + ' ' + top + ' ' + cx + ' ' + top +
            ' C' + (cx + bw * .14) + ' ' + top + ' ' + (cx + bw / 2) + ' ' + (b - ch - bh * .75) + ' ' + (cx + bw / 2) + ' ' + (b - ch);
        return { d: d, labelY: b - ch / 2 - 4 };
      }
      var W = 38, body = h * .52, sh = h * .07, nk = h * .08, bl = h - body - sh - nk, nw = W * .48, nt = b - body - sh - nk;
      d = 'M' + (cx - W / 2) + ' ' + b + ' V' + (b - body) + ' L' + (cx - nw / 2) + ' ' + (b - body - sh) + ' V' + nt + ' H' + (cx + nw / 2) + ' V' + (b - body - sh) +
          ' L' + (cx + W / 2) + ' ' + (b - body) + ' V' + b + ' Z M' + (cx - W / 2) + ' ' + (b - 7) + ' H' + (cx + W / 2) +
          ' M' + (cx - nw / 2) + ' ' + nt + ' C' + (cx - nw / 2) + ' ' + (nt - bl * .7) + ' ' + (cx - nw * .1) + ' ' + top + ' ' + cx + ' ' + top +
          ' C' + (cx + nw * .1) + ' ' + top + ' ' + (cx + nw / 2) + ' ' + (nt - bl * .7) + ' ' + (cx + nw / 2) + ' ' + nt;
      return { d: d, labelY: b - body / 2 - 4, tip: [cx, top, nw, bl] };
    }
    var rounds = ROUNDS.map(function (r, i) {
      var g = el('g', { class: 'rnd', 'data-lv': r[1] }, gR), c = cart(XS[i], r[3], r[2]);
      var p = el('path', { d: c.d }, g), tip = null;
      if (r[5] && c.tip) {
        var t = c.tip, y1 = t[1] + t[3] * .28;
        tip = el('path', { d: 'M' + (t[0] - t[2] * .22) + ' ' + y1 + ' Q' + (t[0] - t[2] * .08) + ' ' + t[1] + ' ' + t[0] + ' ' + t[1] + ' Q' + (t[0] + t[2] * .08) + ' ' + t[1] + ' ' + (t[0] + t[2] * .22) + ' ' + y1 + ' Z', style: 'fill:' + r[5] + ';stroke:var(--sv-zinc-300);stroke-width:1.5' }, g);
      }
      var lab = el('text', { x: 0, y: 0, 'text-anchor': 'middle', transform: 'translate(' + (XS[i] + 3.5) + ' ' + c.labelY + ') rotate(-90)' }, g); lab.textContent = r[0];
      var star = null;
      if (r[4]) {
        var sx = XS[i], sy = BASE - r[3] - 22, pts = [];
        for (var k = 0; k < 10; k++) { var a = -Math.PI / 2 + k * Math.PI / 5, rr = k % 2 ? 4 : 10; pts.push((sx + rr * Math.cos(a)).toFixed(1) + ' ' + (sy + rr * Math.sin(a)).toFixed(1)); }
        star = el('path', { class: 'star', d: 'M' + pts.join(' L') + ' Z' }, g);
      }
      return { g: g, p: p, lab: lab, star: star, tip: tip, lv: r[1] };
    });
    function focus(set) {   // set = the levels to light, or null; rounds above the highest lit level dim
      var top = set ? Math.max.apply(null, set) : null;
      tiers.forEach(function (t) { t.g.classList.toggle('is-on', !!set && set.indexOf(t.t.lv) >= 0); });
      rounds.forEach(function (r) { r.g.classList.toggle('is-dim', set !== null && r.lv > top); });
    }
    tiers.forEach(function (t) {
      t.g.addEventListener('mouseenter', function () { focus([t.t.lv]); });
      t.g.addEventListener('mouseleave', function () { focus(null); });
      t.g.addEventListener('click', function () { focus(t.g.classList.contains('is-on') ? null : [t.t.lv]); });
    });
    all('[data-sv-tl]').forEach(function (card) {   // the two layer cards above the ladder light their levels
      var set = card.getAttribute('data-sv-tl').split(' ').map(Number);
      card.addEventListener('mouseenter', function () { focus(set); });
      card.addEventListener('mouseleave', function () { focus(null); });
    });
    var paths = rounds.map(function (r) { return r.p; }), stars = rounds.filter(function (r) { return r.star; }).map(function (r) { return r.star; });
    var labs = rounds.map(function (r) { return r.lab; }), tips = rounds.filter(function (r) { return r.tip; }).map(function (r) { return r.tip; });
    var bars = tiers.slice().reverse().map(function (t) { return t.bar; }), texts = all('.tier text', svg);
    var tl;
    function finish() {
      if (tl) tl.kill(); tl = null;
      undraw(paths.concat([base]));
      if (window.gsap) gsap.set(bars.concat(texts, labs, tips, stars), { clearProps: 'all' });
    }
    function play() {
      if (!live || still()) return finish();
      if (tl) tl.kill(); focus(null);
      prepDraw(paths.concat([base]));
      gsap.set(bars, { scaleX: 0, transformOrigin: '0% 50%' }); gsap.set(texts, { opacity: 0 }); gsap.set(labs.concat(tips), { opacity: 0 });
      gsap.set(stars, { scale: 0, transformOrigin: '50% 50%' });
      tl = gsap.timeline();
      tl.to(base, drawTo({ duration: .8, ease: 'power2.out' }))
        .to(bars, { scaleX: 1, duration: .8, stagger: .14, ease: 'power3.out' }, '<.2')
        .to(texts, { opacity: 1, duration: .4, stagger: .08 }, '-=.5');
      [0, 1, 2].forEach(function (lv, k) {
        var mine = rounds.filter(function (r) { return r.lv === lv; });
        tl.to(mine.map(function (r) { return r.p; }), drawTo({ duration: .6, stagger: .06 }), k === 0 ? '-=.3' : '-=.35')
          .to(mine.map(function (r) { return r.lab; }).concat(mine.filter(function (r) { return r.tip; }).map(function (r) { return r.tip; })), { opacity: 1, duration: .3, stagger: .05 }, '-=.3');
        var st = mine.filter(function (r) { return r.star; }).map(function (r) { return r.star; });
        if (st.length) tl.to(st, { scale: 1, duration: .45, ease: 'back.out(3)', stagger: .1 }, '-=.15');
      });
      tl.timeScale(2);   // David 2026-10-12: the ladder finishes in half the sampler's time
    }
    if (!live || still()) return finish();
    play(); tl.pause(0);   // hold the first frame until the section enters
    onEnter(section, function () { if (tl) tl.play(); });
  }

  /* ── patch-stitch (the six flag patches we sell) ─────────────────────────────────────────────── */
  function patch(live) {
    var svg = document.getElementById('sv-pt-svg'); if (!svg || svg.childNodes.length) return;
    var section = svg.closest('section') || svg;
    var defs = el('defs', {}, svg);
    var pat = el('pattern', { id: 'sv-pt-loops', width: 7, height: 7, patternUnits: 'userSpaceOnUse' }, defs);
    el('circle', { cx: 3.5, cy: 3.5, r: 1.1, fill: 'rgba(255,255,255,.09)' }, pat);
    var flt = el('filter', { id: 'sv-pt-shadow', x: '-20%', y: '-20%', width: '140%', height: '160%' }, defs);
    var fe = el('feDropShadow', { dx: 0, dy: 6, stdDeviation: 5, 'flood-color': '#000', 'flood-opacity': .7 }, flt);
    var mask = el('mask', { id: 'sv-pt-stitch' }, defs);
    var PX = 160, PY = 120, PW = 320, PH = 200;
    var mPath = el('rect', { x: PX + 6, y: PY + 6, width: PW - 12, height: PH - 12, rx: 13, fill: 'none', stroke: '#fff', 'stroke-width': 16 }, mask);
    el('rect', { x: 40, y: 40, width: 560, height: 360, rx: 18, fill: 'var(--sv-zinc-800)' }, svg);
    el('rect', { x: 40, y: 40, width: 560, height: 360, rx: 18, fill: 'url(#sv-pt-loops)' }, svg);
    var cap = el('text', { x: 62, y: 384, class: 'cap' }, svg); cap.textContent = 'LOOP FIELD · CARGO TOP POCKET';
    var P = el('g', { filter: 'url(#sv-pt-shadow)' }, svg);
    el('rect', { x: PX, y: PY, width: PW, height: PH, rx: 16, fill: '#141414' }, P);
    var FX = PX + 26, FY = PY + 26, FW = PW - 52, FH = PH - 52, CW = FW * .4, SH = FH / 13, CH = SH * 7;
    var flag = el('g', {}, P);
    var stripes = [], stars = [], accent = null;
    for (var i = 0; i < 13; i++) {
      var x0 = i < 7 ? FX + CW : FX, y = FY + SH * i + SH / 2;
      if (i % 2 === 0) stripes.push(el('path', { d: 'M' + x0 + ' ' + y + ' H' + (FX + FW), stroke: '#e6e6e6', 'stroke-width': SH * .8, fill: 'none' }, flag));
      if (i === 7) accent = el('path', { d: 'M' + FX + ' ' + y + ' H' + (FX + FW), stroke: 'transparent', 'stroke-width': SH * .8, fill: 'none' }, flag);
    }
    for (var r = 0; r < 9; r++) {
      var n = r % 2 ? 5 : 6;
      for (var k = 0; k < n; k++) {
        var sx = FX + CW * ((r % 2 ? 2 * k + 2 : 2 * k + 1) / 12), sy = FY + CH * (r + 1) / 10, pts = [];
        for (var q = 0; q < 10; q++) { var a = -Math.PI / 2 + q * Math.PI / 5, rr = q % 2 ? 1.3 : 3.2; pts.push((sx + rr * Math.cos(a)).toFixed(2) + ' ' + (sy + rr * Math.sin(a)).toFixed(2)); }
        stars.push(el('path', { d: 'M' + pts.join(' L') + ' Z', fill: '#e6e6e6' }, flag));
      }
    }
    el('rect', { x: PX + 6, y: PY + 6, width: PW - 12, height: PH - 12, rx: 13, fill: 'none', stroke: 'var(--sv-zinc-500)', 'stroke-width': 9, 'stroke-dasharray': '2.6 1.6', mask: 'url(#sv-pt-stitch)' }, P);

    /* the pick: design + direction; everything on the page that shows the pick follows it */
    var state = { design: 'sub', dir: 'std' };
    var photos = all('.sv-pt__photo img'), prices = all('.sv-pt__price');
    var title = document.getElementById('sv-pt-title'), add = document.getElementById('sv-pt-add');
    function key() { return state.design + '-' + state.dir; }
    function paint() {
      accent.setAttribute('stroke', state.design === 'blu' ? '#3d7be0' : state.design === 'red' ? '#d23b32' : 'transparent');
      flag.setAttribute('transform', state.dir === 'fwd' ? 'translate(' + (2 * (FX + FW / 2)) + ' 0) scale(-1 1)' : '');
    }
    function sync() {
      var k = key(), pick = null;
      photos.forEach(function (i) { i.classList.toggle('is-on', i.getAttribute('data-key') === k); });
      prices.forEach(function (p) { var on = p.getAttribute('data-key') === k; p.classList.toggle('is-on', on); if (on) pick = p; });
      all('#sv-pt-design .sv-pt__chip').forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-design') === state.design); });
      all('#sv-pt-dir .sv-pt__chip').forEach(function (c) { c.classList.toggle('is-on', c.getAttribute('data-dir') === state.dir); });
      if (pick && title) title.textContent = pick.getAttribute('data-title');
      return pick;
    }
    var lines = stripes.concat([accent]), tl;
    function finish() {
      if (tl) tl.kill(); tl = null; paint();
      undraw(lines.concat([mPath]));
      if (window.gsap) gsap.set(stars.concat([P]), { clearProps: 'all' });
      fe.setAttribute('dy', 6); fe.setAttribute('stdDeviation', 5);
    }
    function play(fast) {
      if (!live || still()) return finish();
      if (tl) tl.kill(); paint();
      prepDraw(lines.concat([mPath]));
      gsap.set(stars, { scale: 0, transformOrigin: '50% 50%' });
      gsap.set(P, { y: -46, scale: 1.05, transformOrigin: '50% 50%' }); gsap.set(fe, { attr: { dy: 34, stdDeviation: 22 } });
      tl = gsap.timeline();
      tl.to(mPath, drawTo({ duration: 1.3, ease: 'none' }))
        .to(lines, drawTo({ duration: .55, stagger: .07, ease: 'power1.inOut' }), '-=.2')
        .to(stars, { scale: 1, duration: .25, ease: 'back.out(3)', stagger: { each: .012, from: state.dir === 'fwd' ? 'end' : 'start' } }, '-=.4')
        .to(P, { y: 0, scale: 1, duration: .55, ease: 'back.out(2.2)' }, '+=.15')
        .to(fe, { attr: { dy: 6, stdDeviation: 5 }, duration: .45, ease: 'power2.out' }, '<');
      if (fast) tl.timeScale(1.8);
    }
    function pick(design, dir) { state.design = design; state.dir = dir; sync(); play(true); }
    all('#sv-pt-design .sv-pt__chip').forEach(function (c) { c.addEventListener('click', function () { pick(c.getAttribute('data-design'), state.dir); }); });
    all('#sv-pt-dir .sv-pt__chip').forEach(function (c) { c.addEventListener('click', function () { pick(state.design, c.getAttribute('data-dir')); }); });
    if (add) add.addEventListener('click', function () {
      var t = sync(), v = t && parseInt(t.getAttribute('data-variant'), 10);
      if (v && typeof window.addToCart === 'function') window.addToCart(v);
      else if (t) window.location.href = '/products/' + t.getAttribute('data-sv-price');
    });
    sync();
    if (!live || still()) return finish();
    play(); tl.pause(0);
    onEnter(section, function () { if (tl) tl.play(); });
  }

  function boot() { whenGsap(function (live) { ladder(live); patch(live); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
